import firmwareupgrade from './firmwareupgrade';
export default { firmwareupgrade };
